import ContactDetails from "./ContactDetails";
import ContactForm from "./ContactForm";

interface Props {
  details: string;
  subject: string | null;
  formRef: React.RefObject<HTMLFormElement>;
}

const ContactUsContainer = ({ subject, details, formRef }: Props) => {
  return (
    <section className="global-container lg:p-[4rem] bg-white rounded-[0.5rem] p-[2rem] flex flex-col md:flex-row mb-[7rem] min-h-full">
      <ContactDetails details={details} />
      <ContactForm subject={subject} formRef={formRef} />
    </section>
  );
};

export default ContactUsContainer;
